import {Good} from './good';
import {PackageType} from './package-type';


export interface LoadUnit {
  id: number,

  reference: string, // Referencia

  quantity: number, // Cantidad de mercancia
  typeId: number, // Tipo de unidad de carga -> PackageType

  packageQuantity: number, // Cantidad de paquetes
  packageTypeId: number, // Tipo de paquete -> PackageType

  goodQuantity: number, // Cantidad de mercancia
  commodityId: number, // Mercancia -> Good

  batch: string, // Lote
  serialNumber: string, // Numero de seria

  unitVolume: number, // Volumen
  unitGrossWeight: number, // Peso bruto
  unitNetWeight: number, // Peso neto

  commodity?: Good,
  type?: PackageType,
  packageType?: PackageType,
}

export interface LoadUnitCreate {
  reference: string,
  type: string,
  commodity: string,
  sku: string,
  batch: string,
  serialNumber: string,
  quantity: number,
  unitVolume: number,
  unitGrossWeight: number,
  unitNetWeight: number,
  packageQuantity: number,
  packageTypeId: number
}

export interface LoadUnitTemplate {
  id: number,
  reference?: string,
  typeId?: number,
  commodityId?: number,
  goodQuantity?: number,
  batch?: string,
  serialNumber?: string,
  quantity?: number,
  unitVolume?: number,
  unitGrossWeight?: number,
  unitNetWeight?: number,
  packageQuantity?: number,
  packageTypeId: number,
  commodity?: Good
}

export type LoadUnitTemplateCreate = Omit<LoadUnitTemplate, 'id'>

